import { ADIRParsedResult } from "@api/assessments/assessment-schema-types";
import type { AssessmentLayoutConfig } from "@components/AssessmentFormRenderer/types/layoutTypes";

export const ADI_R_LAYOUT: AssessmentLayoutConfig = {
  parsedResultSchema: ADIRParsedResult,
  sections: [
    {
      type: "text_field",
      key: "Header.Respondent Name",
      label: "Respondent Name",
      editable: false,
    },
    {
      type: "text_field",
      key: "Header.Relation to Subject",
      label: "Relation to Subject",
      editable: false,
    },
    {
      type: "text_field",
      key: "Header.Clinician Name",
      label: "Clinician Name",
      editable: false,
    },
    {
      type: "text_field",
      key: "Header.School/Clinic",
      label: "School/Clinic",
      editable: false,
    },
    {
      type: "text_field",
      key: "Header.Date of Interview",
      label: "Date of Interview",
      editable: true,
      validation: { inputType: "date" },
    },
    {
      type: "score_table",
      label: "A: Qualitative Abnormalities in Reciprocal Social Interaction",
      source: "Scores.A: Qualitative Abnormalities in Reciprocal Social Interaction",
      columns: [
        { key: "Sub-category", label: "Sub-category", editable: false },
        {
          key: "Score",
          label: "Score",
          editable: true,
          validation: { min: 0, max: 30, inputType: "number" },
        },
      ],
    },
    {
      type: "score_table",
      label: "B: Qualitative Abnormalities in Communication",
      source: "Scores.B: Qualitative Abnormalities in Communication",
      columns: [
        { key: "Sub-category", label: "Sub-category", editable: false },
        {
          key: "Score",
          label: "Score",
          editable: true,
          validation: { min: 0, max: 30, inputType: "number" },
        },
      ],
    },
    {
      type: "score_table",
      label: "C: Restricted, Repetitive, and Stereotyped Patterns of Behavior",
      source: "Scores.C: Restricted, Repetitive, and Stereotyped Patterns of Behavior",
      columns: [
        { key: "Sub-category", label: "Sub-category", editable: false },
        {
          key: "Score",
          label: "Score",
          editable: true,
          validation: { min: 0, max: 30, inputType: "number" },
        },
      ],
    },
    {
      type: "score_table",
      label: "D: Abnormality of Development Evident at or Before 36 Months",
      source: "Scores.D: Abnormality of Development Evident at or Before 36 Months",
      columns: [
        { key: "Sub-category", label: "Sub-category", editable: false },
        {
          key: "Score",
          label: "Score",
          editable: true,
          validation: { min: 0, max: 30, inputType: "number" },
        },
      ],
    },
  ],
};
